import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ElectionContextProviderService {
  public electionId: string | undefined = undefined;
}
